import {
    Component,
    Input,
    ChangeDetectionStrategy,
    Output,
    EventEmitter,
} from '@angular/core';
import { Router } from '@angular/router';

import { take } from 'rxjs';

import { ClassCreationURL } from '@app/public/public/classes/class-session-state/class-session';

import { SnackBarService } from '@shared/snack-bar/snack-bar.service';

import { ClassroomService } from '@public/classroom/services/classroom.service';

@Component({
    selector: 'vsc-join-class',
    templateUrl: './join-class.component.html',
    styleUrls: ['./join-class.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class JoinClassComponent {
    @Input() classSessionId: string;
    @Input() text: string = 'Join program';
    @Input() isLiveStream: boolean;
    @Input() isZoomEmbedded: boolean;
    @Input() classId: string;
    @Input() isZoomCreated: boolean;
    createClassId: string = null;
    @Output() loadingChange = new EventEmitter<boolean>();

    constructor(
        private router: Router,
        private classroomService: ClassroomService,
        private snackBar: SnackBarService,
    ) {}

    navigateToClassroom(
        classSessionId: string,
        classId: string = null,
        isZoomCreated: boolean = null,
    ): void {
        this.loadingChange.emit(true);

        if (this.isLiveStream && classId != null) {
            this.router.navigate([
                `/classes/${classId}/sessions/${classSessionId}`,
            ]);
            this.classroomService
                .recordClassAttendance(classSessionId)
                .pipe(take(1))
                .subscribe({
                    complete: () => this.loadingChange.emit(false),
                    error: () => this.loadingChange.emit(false),
                });
        } else if (isZoomCreated) {
            this.router.navigate([`/classroom/${classSessionId}/join`]);
            this.loadingChange.emit(false);
        } else if (!isZoomCreated) {
            this.classroomService
                .createMeeting(classSessionId)
                .pipe(take(1))
                .subscribe({
                    next: (classCreationUrl: ClassCreationURL) => {
                        if (
                            classCreationUrl.roomUrl &&
                            classCreationUrl.hostRoomUrl
                        ) {
                            this.router.navigate([
                                `/whereby-classroom-sdk/${classSessionId}/join`,
                            ]);
                        } else {
                            this.snackBar.open(
                                'Something Went Wrong. Please Try Again.',
                                'assertive',
                            );
                        }

                        setTimeout(() => {
                            this.loadingChange.emit(false);
                        }, 2000);
                    },
                });
        } else {
            this.snackBar.open('Something Went Wrong', 'assertive');
        }
    }
}
